import * as React from 'react';
import { ComponentProps, ComplexValue } from 'ui/common';
import { Expandable } from 'ui';
import { ExpandableButtonPosition } from 'ui/expandable/expandable';
import styles from './mail-log-link.scss';

export interface MailLogLinkProps extends ComponentProps{
  value?: ComplexValue<number>;
  textDisplayMore?: string;
  textDisplayLess?: string;
}

export class MailLogLink extends React.Component<MailLogLinkProps> {
  private expander = (collapsed: boolean) => {
    const contents = <div className={styles.mailLogContainer}>{this.props.children}</div>;
    return !collapsed ?  contents: null;
  };

  public render() {

  const {
    componentId,
    value,
    textDisplayMore,
    textDisplayLess
  } = this.props;

  if (!value) {
    return null;
  }

    return (
      <div id={componentId} className={styles.buttonContainer}>
        <Expandable
          content={this.expander}
          useMargin={false}
          buttonPosition={ExpandableButtonPosition.top}
          textDisplayMore={textDisplayMore}
          textDisplayLess={textDisplayLess} />
      </div>
    );
  }
}
